export const PUT_CITY = "PUT_CITY";
export const PUT_CITIES = "PUT_CITIES";
export const GET_CITIES = "GET_CITIES";
export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
